import React from 'react'
import PropTypes from 'prop-types'
import Dialog, {DialogContent} from 'material-ui/Dialog'
import {withStyles} from 'material-ui/styles'
import {Flow, FlowStep, FlowHeader} from '../../flow'
import {LoadingIndicator} from '../../../components'
import CalendarStep from '../containers/calendar'
import SummaryStep from '../containers/summary'
import DoneStep from '../containers/done'
import PhoneStep from '../containers/phone'
import AddressStep from '../containers/address'
import CardStep from '../containers/paymentMethod'

const styles = theme => ({
  Dialog: {
    backgroundColor: theme.palette.background.modal,
  },
  FlowContainer: {
    // maxWidth: theme.breakpoints.values['sm'],
    margin: '0 auto',
  },
})

class Orchestrator extends React.PureComponent {

  static displayName = 'RemoveOrchestrator.Component'

  static propTypes = {
    isOpen: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    flowStep: PropTypes.string.isRequired,
    setFlowStep: PropTypes.func.isRequired,
    flowReset: PropTypes.bool.isRequired,
    setFlowReset: PropTypes.func.isRequired,
    flowLoading: PropTypes.bool.isRequired,
    setFlowLoading: PropTypes.func.isRequired,
    updateUserInfo: PropTypes.func.isRequired,
  }

  isMissingAddress = () => {
    this.props.setFlowLoading(true)
    return this.props.updateUserInfo()
      .then(user => {
        this.props.setFlowLoading(false)
        if (user) return user.missingProfileInformation.find(i => i === 'address') !== undefined
        return true
      })
  }
  isMissingPhoneNumber = () => {
    this.props.setFlowLoading(true)
    return this.props.updateUserInfo()
      .then(user => {
        this.props.setFlowLoading(false)
        if (user) return user.missingProfileInformation.find(i => i === 'phone') !== undefined
        return true
      })
  }
  isMissingPaymentMethod = () => {
    return Promise.resolve(false) // No longer a requirement
    // this.props.setFlowLoading(true)
    // return this.props.updateUserInfo()
    //   .then(user => {
    //     this.props.setFlowLoading(false)
    //     if (user) return user.missingProfileInformation.find(i => i === 'card') !== undefined
    //     return true
    //   })
  }

  showBackButton = () => this.props.flowStep !== 'done'

  render() {
    const {classes} = this.props
    return (
      <Dialog open={this.props.isOpen} onClose={this.props.onClose} fullWidth fullScreen>
        <DialogContent className={classes.Dialog}>
          <Flow
            stepKey={this.props.flowStep}
            setStep={this.props.setFlowStep}
            reset={this.props.flowReset}
            setReset={this.props.setFlowReset}
            loading={this.props.flowLoading}
            setLoading={this.props.setFlowLoading}
            onExit={this.props.onClose}
            onFinish={this.props.onClose}
            containerClass={classes.FlowContainer}
          >
            <FlowHeader back={{show: this.showBackButton()}} title={'Programar envío'} close={{show: true}}/>
            <FlowStep stepKey={'default'} default={true} component={defaultStep}/>
            <FlowStep stepKey={'address'}
                      condition={this.isMissingAddress} alwaysCheck={false} ignoreWhenBacking={true}
                      component={AddressStep}/>
            <FlowStep stepKey={'phone'}
                      condition={this.isMissingPhoneNumber} alwaysCheck={false} ignoreWhenBacking={true}
                      component={PhoneStep}/>
            <FlowStep stepKey={'payment'}
                      condition={this.isMissingPaymentMethod} alwaysCheck={false} ignoreWhenBacking={true}
                      component={CardStep}/>
            <FlowStep stepKey={'calendar'}
                      component={CalendarStep}/>
            <FlowStep stepKey={'summary'}
                      component={SummaryStep}/>
            <FlowStep stepKey={'done'}
                      component={DoneStep}/>
          </Flow>
        </DialogContent>
      </Dialog>
    )
  }
}

export default withStyles(styles, {withTheme: true})(Orchestrator)

const defaultStep = ({loading}) => (
  <LoadingIndicator show={loading}><div/></LoadingIndicator>
)




// WEBPACK FOOTER //
// ./src/sections/remove/components/orchestrator.jsx